import { makeDictNameById } from "src/types/AttrType";
import { getIdLabels } from "./getIdNames";

export const getTypesMap = () =>
  getIdLabels("attrType", "attrType").then(makeDictNameById);
